import { Box } from "@mui/material";
import ContactUs from "../ContactUs/ContactUs";
import Header from "./components/Header/Header";
import Services from "./components/Services/Services";
import WhyUs from "./components/WhyUs/WhyUs";
import Quality from "./components/Quality&Complience";

const HomePage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: { xs: 5, md: 10 },
        backgroundColor: "#FBFBFB",
      }}
    >
      <Header />
      <Services />
      <WhyUs />
      <Quality />
      <ContactUs
        textAlign="center"
        title="El Deeb for Import, Export & TA Limited"
        description=""
      />
    </Box>
  );
};
export default HomePage;
